import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import './Spacing.css'

export class Layout extends Component {
  static displayName = Layout.name;

    
  render () {
    return (
      <div>
            <NavMenu showHosting={this.props.showHosting} />
            <Container className="space-content-beneath-header">
                {this.props.children}
            </Container>
            <p className="font-weight-light text-center space-footer">&copy; 2023 OST - Ostschweizer Fachhochschule<br/>Studiengang Wirtschaftsingenieurwesen</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.jsx